import React from "react";

import { AgeBandedRate } from "../../constants/aquafina";
import { CoverageArrowRow, CoverageRow } from "../table/rows";
import { CoverageCell, CoverageHeaderCell } from "../table/cells";
import { RangeIterator } from "../../utils";

const AgeBandedRates = ({
  rates,
  headerTitle = "Rates",
}: {
  rates: AgeBandedRate[];
  headerTitle?: string;
}) => {
  const tiers = new Map<string, string[]>();
  RangeIterator(rates.length, (index) => {
    rates[index]?.tiers?.forEach((tier) => {
      const tierName = tier.name;
      if (!tierName) return;
      if (!tiers.has(tierName)) {
        tiers.set(tierName, new Array(rates.length).fill(""));
      }
      (tiers.get(tierName) as string[])[index] = tier.value;
    });
  });

  return (
    <>
      <CoverageRow label="Rate Unit">
        {RangeIterator(rates.length, (index) => (
          <CoverageCell value={rates[index].rateUnit} key={index} />
        ))}
      </CoverageRow>
      <CoverageRow label={headerTitle} isWhite>
        {RangeIterator(rates.length, (index) => (
          <CoverageHeaderCell label={""} key={index} />
        ))}
      </CoverageRow>
      {Array.from(tiers.entries()).map(([label, values], indexTier) => (
        <CoverageArrowRow
          key={label}
          label={label}
          isWhite={indexTier % 2 !== 0}
        >
          {values.map((value, index) => (
            <CoverageCell value={value} key={index} />
          ))}
        </CoverageArrowRow>
      ))}
    </>
  );
};

export default AgeBandedRates;
